'use es6';

import PropTypes from 'prop-types';
import UIList from 'UIComponents/list/UIList';
import Small from 'UIComponents/elements/Small';
import BulkDeleteButton from './BulkDeleteButton';
import BulkMoveButton from './BulkMoveButton';
import BulkChangeVisibilityButtonAndModal from './BulkChangeVisibilityButtonAndModal';
import ExportFilesAndButtonsContainer from '../ExportFilesAndButtonsContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BulkActions = ({
  selectedCount
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(Small, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "FileManagerDashboard.selectedCount",
      options: {
        count: selectedCount
      }
    })
  }), /*#__PURE__*/_jsxs(UIList, {
    inline: true,
    childClassName: "m-left-3",
    children: [/*#__PURE__*/_jsx(BulkMoveButton, {}), /*#__PURE__*/_jsx(BulkDeleteButton, {}), /*#__PURE__*/_jsx(BulkChangeVisibilityButtonAndModal, {}), /*#__PURE__*/_jsx(ExportFilesAndButtonsContainer, {
      isExportingSelection: true
    })]
  })]
});
BulkActions.propTypes = {
  selectedCount: PropTypes.number.isRequired
};
export default BulkActions;